import { createSlice } from '@reduxjs/toolkit';
// import Swal from 'sweetalert2';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { jwtCheck, setToken } from '../../_helpers/jwt-check';
import { ErrorMessageHandler } from '../../_helpers/_methods';
import { setUiError, setUiMessage } from './ui';

export const initialState = {
  loading: false,
  hasErrors: false,
  users: [],
  user: null,
  promotionUser: {},
  permissions: {},
  isLoggedIn: jwtCheck() ? true : false
};

const permissionObjectGenerator = (permissions) => {
  var object = permissions.reduce((obj, item) => Object.assign(obj, { [item]: true }), {});
  return object;
};

// A slice
const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.permissions = permissionObjectGenerator(action.payload.permissions);
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    setUserLogin: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
    },
    setUserLogout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
      state.permissions = {};
    },
    addUser: (state, action) => {
      state.users.unshift(action.payload);
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    getUsersSuccess: (state, action) => {
      state.users = action.payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getUsersFailure: (state) => {
      state.loading = false;
      //handling Errors
      state.hasErrors = true;
    },
    setPromotionUser: (state, action) => {
      state.promotionUser = action.payload;
    },
    removePromotionUser: (state) => {
      state.promotionUser = null;
    }
  }
});

// Actions generated from the slice
const {
  setUser,
  updateUser,
  setUserLogin,
  setUserLogout,
  addUser,
  startLoading,
  stopLoading,
  getUsersFailure,
  setPromotionUser,
  removePromotionUser
} = usersSlice.actions;

// export user selector to get the slice in any component
export const usersSelector = (state) => state.users;
export const userSelector = (state) => state.users.user;

// export The reducer
const userReducer = usersSlice.reducer;

export default userReducer;

// Actions

export const createUser = (User) => async (dispatch) => {
  try {
    dispatch(addUser(User));
  } catch (error) {
    dispatch(getUsersFailure());
  }
};

export const handleUpdateUser = (User) => async (dispatch) => {
  try {
    dispatch(updateUser(User));
  } catch (error) {
    ErrorMessageHandler(error);
  }
};

export const loginUser = (credentials, navigate, redirectTo) => async (dispatch) => {
  try {
    dispatch(startLoading());
    let response = await fetchWrapper.post('/auth/jwt/create/', credentials);
    let accessToken = {
      token: response.data.access
    };
    let refreshToken = {
      token: response.data.refresh
    };
    let role = response.data.role;
    setToken(accessToken, refreshToken, role);
    dispatch(stopLoading());
    dispatch(setUserLogin(response.data));
    navigate(redirectTo);

    if (navigate) {
      if (redirectTo) {
        navigate(redirectTo);
      } else {
        navigate('/admin');
      }
    }
  } catch (err) {
    dispatch(stopLoading());
    ErrorMessageHandler(err);
  }
};

export const loginWithOtp = (credentials, navigate, redirectTo) => async (dispatch) => {
  try {
    dispatch(startLoading());
    let response = await fetchWrapper.post('/login-with-otp/', credentials);
    let accessToken = {
      token: response.data.access
    };
    let refreshToken = {
      token: response.data.refresh
    };
    let role = response.data.role;
    setToken(accessToken, refreshToken, role);
    dispatch(stopLoading());
    dispatch(setUserLogin(response.data));
    if (navigate) {
      if (redirectTo) {
        navigate(redirectTo);
      } else {
        navigate('/admin');
      }
    }
  } catch (err) {
    console.log(err, 'err');
    ErrorMessageHandler(err);
    dispatch(stopLoading());
  }
};

export const getUserData = () => async (dispatch) => {
  try {
    const user = await fetchWrapper.get(`/user/me/`);
    dispatch(setUser(user.data));
  } catch (err) {
    dispatch(setUserLogout());
  }
};

export const logoutUser = () => async (dispatch) => {
  localStorage.removeItem('cdmin_user');
  localStorage.removeItem('cdmin_userRefresh');
  localStorage.removeItem('cdmin_role');
  dispatch(setUserLogout());
};

export const forgetPassword = (credentials, navigate) => async (dispatch) => {
  try {
    dispatch(startLoading());
    await fetchWrapper.post('/user/reset_password/', credentials);
    dispatch(stopLoading());
    navigate('/signin');
  } catch (err) {
    ErrorMessageHandler(err);
    console.log(err, 'err');
    dispatch(stopLoading());
    let errorMessage = err.error?.non_field_error || err.message;
    dispatch(setUiError(errorMessage));
  }
};

export const restPassword = (credentials, navigate) => async (dispatch) => {
  try {
    dispatch(startLoading());
    await fetchWrapper.post('/user/reset_password_confirm/', credentials);
    dispatch(stopLoading());
    dispatch(setUiMessage('Password reset successfully'));
    navigate('/signin');
  } catch (err) {
    ErrorMessageHandler(err);
    console.log(err, 'err');
    dispatch(stopLoading());
    let errorMessage = err.error?.non_field_error || err.message;
    dispatch(setUiError(errorMessage));
  }
};

export const deleteUser = (credentials, navigate) => async (dispatch) => {
  try {
    dispatch(startLoading());
    await fetchWrapper.post('/user/reset_password_confirm/', credentials);
    dispatch(stopLoading());
    dispatch(setUiMessage('Password reset successfully'));
    navigate('/signin');
  } catch (err) {
    ErrorMessageHandler(err);
    console.log(err, 'err');
    dispatch(stopLoading());
    let errorMessage = err.error?.non_field_error || err.message;
    dispatch(setUiError(errorMessage));
  }
};

export const promoteUser = (user) => async (dispatch) => {
  try {
    dispatch(setPromotionUser(user));
  } catch (err) {
    ErrorMessageHandler(err);
    console.log(err, 'err');
  }
};
export const clearPromoteUser = () => async (dispatch) => {
  try {
    dispatch(removePromotionUser());
  } catch (err) {
    ErrorMessageHandler(err);
    console.log(err, 'err');
  }
};
